import { Typography, TextField } from "@mui/material";

const NotesSection = ({ notes, onNotesChange, language }) => {
  return (
    <div className="notes-section" style={{ margin: "20px 0" }}>
      <Typography
        variant="h6"
        component="h3"
        style={{
          marginBottom: "10px",
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {language === "ar" ? "ملاحظات إضافية" : "Additional Notes"}
      </Typography>
      <TextField
        multiline
        rows={4}
        fullWidth
        variant="outlined"
        placeholder={
          language === "ar"
            ? "مثال: سقف البناء أعلى من 3 أمتار سنحتاج سلم، المكان مظلم قد تحتاج إلى مصدر إضاءة"
            : "Example: Building ceiling is higher than 3 meters, will need a ladder. Place is dark, might need lighting source"
        }
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ddd",
            },
            "&:hover fieldset": {
              borderColor: "#007bff",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#007bff",
            },
          },
          "& .MuiInputBase-input": {
            fontSize: "14px",
            padding: "12px",
          },
        }}
      />

    </div>
  );
};

export default NotesSection;